module.exports = __webpack_public_path__ + "static/z16-PUCK_UJECIE_1-tablet-36085f0ab86846d5c6650f200842f165.jpg";